export interface IMail {
  starred: boolean;
  unread: boolean;
  folders: string[];
  subject: string;
  threadId: string;
  body: string | null;
  grantId: string;
  id: string;
  object: string;
  snippet: string;
  bcc: any[];
  cc: any[];
  attachments: any[];
  from: From[];
  replyTo: any[];
  to: To[];
  date: number;
  logs :string[]; 
}

export interface From {
  name: string;
  email: string;
}

export interface To {
  email: string;
}

export interface IPageToken {
  pageIndex: number;
  pageToken: string;
}

export interface IFolder {
  id: string;
  grantId: string;
  name: string;
  object: string;
  attributes: any[];
  totalCount: number;
  unreadCount: number;
  systemFolder: boolean;
  icon?: JSX.Element;
  displayName?: string;
  index: number;
}

export interface IComposeEmailData {
  email: string;
  to: string[];
  subject: string | undefined;
  body: string;
  attachments: any[];
}

export interface IMailBoxAuthData {
  id: string;
  email: string;
  grantId: string;
  userId: string;
  accessToken: string;
  refreshToken: string;
  provider:MailboxProvider | string;
  tokenExpiry: string; // or `Date` if you parse it
  createdAt: string; // or `Date` if you parse it
  updatedAt: string; // or `Date` if you parse it
}

export enum MailboxProvider {
  GMAIL = "google",
  OUTLOOK = "outlook"
}